// ChatAPI.js — centralized HTTP layer for the chat feature.
import axios from 'axios';

const BASE = 'https://skcapi.btcjapan.co';

const authHeader = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchConversations = async () => {
    const res = await axios.get(`${BASE}/chat_get_conversations.php`, {
        headers: authHeader()
    });
    return res.data;
};

export const fetchMessages = async (threadId, before = null) => {
    const params = { thread_id: threadId, limit: 50 };
    if (before) params.before = before;
    const res = await axios.get(`${BASE}/chat_get_messages.php`, {
        headers: authHeader(),
        params
    });
    return res.data;
};

export const sendMessage = async ({ recipient_ids, body, thread_type = 'dm', title = '', attachment = null }) => {
    const payload = { recipient_ids, body, thread_type, title };
    if (attachment) payload.attachment = attachment; // { name, type, data (base64) }
    const res = await axios.post(`${BASE}/chat_send.php`, payload, {
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    });
    return res.data;
};

export const markThreadRead = async (threadId) => {
    const res = await axios.post(`${BASE}/chat_mark_read.php`, { thread_id: threadId }, {
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    });
    return res.data;
};

export const announceTyping = async (threadId) => {
    try {
        await axios.post(`${BASE}/chat_typing.php`, { thread_id: threadId }, {
            headers: { ...authHeader(), 'Content-Type': 'application/json' }
        });
    } catch (_) { /* silent — typing is best-effort */ }
};

export const getTypingUsers = async (threadId) => {
    const res = await axios.get(`${BASE}/chat_typing.php`, {
        headers: authHeader(),
        params: { thread_id: threadId }
    });
    return res.data;
};

export const fetchAllUsers = async (q = '') => {
    const res = await axios.get(`${BASE}/chat_get_users.php`, {
        headers: authHeader(),
        params: q ? { q } : {}
    });
    return res.data;
};

export const fetchUnreadCount = async () => {
    const res = await axios.get(`${BASE}/chat_get_unread_count.php`, {
        headers: authHeader()
    });
    return res.data;
};

/**
 * Convert a File object to base64 payload for chat_send.php
 */
export const fileToBase64Payload = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
        const base64 = reader.result.split(',')[1];
        resolve({
            name: file.name,
            type: file.type,
            size: file.size,
            data: base64
        });
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
});